export enum DoorBuilderOptionsEnum {
  DO_NOT_DRILL = 'DO NOT DRILL',
  BLUM_1INCH = 'BLUM 1INCH',
  KNIFE = 'KNIFE',
  SPECIAL = 'SPECIAL',
}

export const LIPPED_DOOR_EDGES = ['LIP-C', 'LIP-D', 'LIP-G'];
